// Horizontaal Stepper voor A→G op het grote scherm; op mobiel is er al de
// drawer-sidebar — stepper hier is dus optioneel (hidden xs).

import React from 'react';
import { Stepper, Step, StepButton, StepLabel, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function ProgressStepper({ clusters, currentClusterId, projectId, progress }) {
    const navigate = useNavigate();
    const activeStep = clusters.findIndex(c => c.id === currentClusterId);

    return (
        <Box sx={{ display: { xs: 'none', md: 'block' }, mb: 3 }}>
            <Stepper nonLinear activeStep={activeStep}>
                {clusters.map(cluster => {
                    const p = progress?.[cluster.id];
                    const completed = p?.complete && p.total > 0;
                    return (
                        <Step key={cluster.id} completed={completed}>
                            <StepButton
                                color="inherit"
                                onClick={() => navigate(`/projects/${projectId}/wizard/${cluster.id}`)}
                            >
                                <StepLabel>{cluster.id}</StepLabel>
                            </StepButton>
                        </Step>
                    );
                })}
            </Stepper>
        </Box>
    );
}
